import {Component, OnInit} from '@angular/core';
import {SidebarComponent} from '../sidebar/sidebar.component';
import {RouterModule} from '@angular/router';
import {HeaderComponent} from '../header/header.component';
import {User} from '../../interfaces/loginInterface';
import {LoginService} from '../../core/services/login-service/login.service';
import {UserService} from '../../core/services/user-service/user.service';
import {FooterComponent} from '../footer/footer.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [SidebarComponent, RouterModule, HeaderComponent, SidebarComponent, FooterComponent],
  providers: [],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css'
})
export class LayoutComponent implements OnInit {

  constructor(
    private loginService: LoginService,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.getLoggedInUserProfile()
  }

  getLoggedInUserProfile(): void {
    this.loginService.getCustomerLoginUser().subscribe({
      next: (res: User) => {
        this.userService.setUser(res);
      },
      error: err => {
        console.error('Failed to load user profile', err);
      }
    });
  }
}
